import { types } from 'mobx-state-tree';
import { BaseEntity } from './BaseEntity';

export const Municipality = types.compose(
  BaseEntity,
  types.model('Municipality', {
    municipalityId: types.identifierNumber,
    insCode: types.string,
    nameFR: types.string,
    nameNL: types.string,
    isMain: types.boolean,
    mainINSCode: types.string,
    mainNameFR: types.string,
    mainNameNL: types.string,
    population: types.integer,
    postalCode: types.integer,
    nbrPharmaciesMain: types.integer,
  }),
);
